import Typography from "@mui/material/Typography";
import {GenreSelectorMultiple} from "@/components/bandcreate/GenreSelectorMultiple";

const NetworkLocationFormMusikverlage = ({onChange}) => {
    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Musikverlage)
            </Typography>
            <GenreSelectorMultiple
                label="Genre *"
                hint="Wähle bis zu vier"
                onChange={handleInputChanged}
                maxCount="4"
            />
        </>
    )
}

export default NetworkLocationFormMusikverlage;
